import { ElementActionType } from '@agoda/analytics-data-acquisition';
import { useElementAnalytics } from '@agoda/analytics-data-acquisition-react';
import {
    UniversalLoginWalletOtpFormElementUniversalLoginFieldsV1,
    UniversalLoginWalletOtpFormElementUniversalLoginIdsV1,
    UniversalLoginWalletOtpSubmitButtonElementUniversalLoginFieldsV1,
    UniversalLoginWalletOtpSubmitButtonElementUniversalLoginIdsV1,
    UniversalLoginWalletResendOtpWithTimerButtonElementUniversalLoginFieldsV1,
    UniversalLoginWalletResendOtpWithTimerButtonElementUniversalLoginIdsV1,
} from '@agoda/analytics-messages-definition-universal-login/elements.split';
import {
    UniversalLoginWalletOtpFormElementUniversalLoginManifestV1,
    UniversalLoginWalletOtpSubmitButtonElementUniversalLoginManifestV1,
    UniversalLoginWalletResendOtpWithTimerButtonElementUniversalLoginManifestV1,
} from '@agoda/analytics-messages-definition-universal-login/manifest/elements';

export const useAnalytics = () => {
    const AnalyticsOtpFormProps = useElementAnalytics<
        UniversalLoginWalletOtpFormElementUniversalLoginIdsV1,
        UniversalLoginWalletOtpFormElementUniversalLoginFieldsV1
    >([ElementActionType.Seen], UniversalLoginWalletOtpFormElementUniversalLoginManifestV1.ids, []);

    const AnalyticsSubmitButtonProps = useElementAnalytics<
        UniversalLoginWalletOtpSubmitButtonElementUniversalLoginIdsV1,
        UniversalLoginWalletOtpSubmitButtonElementUniversalLoginFieldsV1
    >([ElementActionType.Click], UniversalLoginWalletOtpSubmitButtonElementUniversalLoginManifestV1.ids, []);

    const AnalyticsResendOtpButtonProps = useElementAnalytics<
        UniversalLoginWalletResendOtpWithTimerButtonElementUniversalLoginIdsV1,
        UniversalLoginWalletResendOtpWithTimerButtonElementUniversalLoginFieldsV1
    >([ElementActionType.Click], UniversalLoginWalletResendOtpWithTimerButtonElementUniversalLoginManifestV1.ids, []);

    return {
        AnalyticsOtpFormProps,
        AnalyticsSubmitButtonProps,
        AnalyticsResendOtpButtonProps,
    };
};
